import { trackEvent } from '../../lib/analytics';

export const FETCH_CONVERSATION_BEGIN   = 'FETCH_CONVERSATION_BEGIN';
export const FETCH_CONVERSATION_SUCCESS = 'FETCH_CONVERSATION_SUCCESS';
export const FETCH_CONVERSATION_FAILURE = 'FETCH_CONVERSATION_FAILURE';
export const ADD_MESSAGE_BEGIN   = 'ADD_MESSAGE_BEGIN';
export const ADD_MESSAGE_SUCCESS = 'ADD_MESSAGE_SUCCESS';
export const ADD_MESSAGE_FAILURE = 'ADD_MESSAGE_FAILURE';
export const DELETE_MESSAGE_BEGIN   = 'DELETE_MESSAGE_BEGIN';
export const DELETE_MESSAGE_SUCCESS = 'DELETE_MESSAGE_SUCCESS';
export const DELETE_MESSAGE_FAILURE = 'DELETE_MESSAGE_FAILURE';

export const fetchConversationBegin = (opts) => ({
  type: FETCH_CONVERSATION_BEGIN,
  opts
});

export const fetchConversationSuccess = (drafts, opts) => ({
  type: FETCH_CONVERSATION_SUCCESS,
  payload: { drafts },
  opts
});

export const fetchConversationFailure = (error, opts) => ({
  type: FETCH_CONVERSATION_FAILURE,
  payload: { error },
  opts
});

export const AddMessageBegin = (opts) => ({
  type: ADD_MESSAGE_BEGIN,
  opts
});

export const AddMessageSuccess = (message, opts) => ({
  type: ADD_MESSAGE_SUCCESS,
  message: { message },
  opts
});

export const AddMessageFailure = (error, opts) => ({
  type: ADD_MESSAGE_FAILURE,
  payload: { error },
  opts
});

const DeleteMessageBegin = (opts) => ({
  type: DELETE_MESSAGE_BEGIN,
  opts
});

const DeleteMessageSuccess = (message, opts) => ({
  type: DELETE_MESSAGE_SUCCESS,
  message,
  opts
});

const DeleteMessageFailure = (error, opts) => ({
  type: DELETE_MESSAGE_FAILURE,
  payload: { error },
  opts
});

export function fetchConversation(opts = {}) {
  return (dispatch, getState) => {
    dispatch(fetchConversationBegin(opts));
    let url = opts.query.url;
    let newQuery = { ...opts.query };
    delete newQuery.url;
    fetch(`${url}.json/?${$.param(newQuery)}`)
      .then((response) => response.json())
      .then((data) => { dispatch(fetchConversationSuccess(data, opts)); })
      .then(() => {
        if (opts.callback) {
          opts.callback();
        }
        return true;
      })
      .catch(error => dispatch(fetchConversationFailure(error, opts)));
  };
}

export function addMessage(opts = {}) {
  return (dispatch) => {
    dispatch(AddMessageBegin(opts));
    let url = `${opts.url}_message.json`;
    let token = $('meta[name="csrf-token"]').attr('content');
    fetch(url, {
      body: JSON.stringify({ message: opts.message }),
      method: "POST",
      headers: { 'X-CSRF-Token': token, 'Content-Type': 'application/json' } })
      .then((response) => response.json())
      .then((data) => {
        dispatch(AddMessageSuccess(data, opts));
        trackEvent('Send Message', 'ChatBox');
      })
      .then(() => {
        if (opts.callback) {
          opts.callback();
        }
        return true;
      })
      .catch(error => dispatch(AddMessageFailure(error, opts)));
  };
}

export function deleteMessage(opts = {}) {
  return (dispatch) => {
    dispatch(DeleteMessageBegin(opts));
    let url = `${opts.url}_message_delete.json`;
    let token = $('meta[name="csrf-token"]').attr('content');
    fetch(url, {
      body: JSON.stringify({ message_id: opts.messageId }),
      method: "DELETE",
      headers: { 'X-CSRF-Token': token, 'Content-Type': 'application/json' } })
      .then((response) => response.json())
      .then((data) => {
        dispatch(DeleteMessageSuccess(data, opts));
        trackEvent('Delete Message', 'ChatBox');
      })
      .then(() => {
        if (opts.callback) {
          opts.callback();
        }
        return true;
      })
      .catch(error => dispatch(DeleteMessageFailure(error, opts)));
  };
}

function handleErrors(response) {
  if (!response.ok) {
    throw Error(response.statusText);
  }
  return response;
}